module.exports = __webpack_public_path__ + "img/chaxun_02.130b1c25.png";